module.exports = __webpack_public_path__ + "img/re-activate.e8b11cd0.svg";